import React, { Component } from 'react'
import { Radio, Button, Spin } from 'antd'
// 导入组件
import InformationFilling from './PreparatoryTeamApplicationDirectory/InformationFilling'   //筹备组申请信息填写
import AddTeamMembers from './PreparatoryTeamApplicationDirectory/AddTeamMembers'   //筹备组申请信息填写
import UploadInformation from './PreparatoryTeamApplicationDirectory/UploadInformation'   //资料上传
import MyApplication from './PreparatoryTeamApplicationDirectory/MyApplication'   //我的申请
import style from './teamApplication.css'

// 导入功能组件
import { app } from '../../app'
import { Link } from 'react-router-dom';




class PreparatoryTeamApplication extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        
        this.state = {
            page: 1, //当前页面为page1
            agreeFlagRadio: false,
            spin:true
        }

    }



    componentWillMount() {
        this.setState({
            spin:false
        })
    }

    // 点击我的申请时触发的操作
    componentDidUpdate() {
        if (this.props.setPageToApplication) {
            this.props.setPageToApplicationFun(false)
            this.setState({
                page: 5
            })

        }
        
        if (this.props.setPage) {
            this.props.setDafaultView(false)
            this.setState({
                page: 1
            })

        }
    }

    getRouterPage = () => {
        console.log(this.props)
    }

    // 是否阅读并且了解按钮
    RadioChang = (e) => {
        this.setState({
            agreeFlagRadio: e.target.checked
        })
    }

    // 跳转下一页(首页专属)
    navigatorToNextPage = () => {
        //当用户已点击了已阅读按钮则允许跳转
        console.log(this.state.agreeFlagRadio)
        if (this.state.agreeFlagRadio) {
            this.setState({
                page: 2
            })
        } else {
            app.alert('请点击"我已阅读并已了解须知与要求"按钮', 'error', '45%')
        }
    }

    // 修改当前所在page页
    setPage(page) {
        //把子组件传递过来的值赋给this.state中的属性
        this.setState({
            page: page
        });
    }



    // 页面渲染区
    render() {
        // itemNode = (<ChangeTeam team_id={team_id}/>);
        let { page, agreeFlagRadio } = this.state,pageContent = null
        // 需要渲染在页面上的内容
        // let pageContent = null
        
        

        // 筹备组申请首页
        const indexPage = (
            <div>
                {/* 申请筹备组须知 */}
                
                <div  style={{marginBottom:20}}>
                    <h3  style={{fontWeight: 'bold'}}>
                        申请筹备组须知
                    </h3>
                    <p>1、存心救援对于品牌管理使用统一着装、统一理念制度、统一培训体系、统一救援协调。</p>
                    <p>2、各地的日常管理、人员、财务、装备由各队独立负责。</p>
                    <p>3、存心救援的所有活动要求符合国家法律和相关规定。</p>
                    <p>4、认同存心救援公约和理念制度。</p>
                </div>
                {/* 申请筹备组须知end */}

                {/* 横线 */}
                <hr style={{opacity: 0.2}} />
                {/* 横线end */}

                {/* 申请筹备组要求 */}
                <div style={{marginBottom:20}}>
                    <h3 style={{fontWeight: 'bold'}}>
                        申请筹备组要求
                    </h3>
                    <p>1、申请存心救援品牌授权的队伍要具备<span   style={{fontWeight: 800,color:'red'}}>10名以上</span>的骨干队员，并且已达到存心救援队志愿者身份或以上（包含预备队员和正式队员）。如未达到身份要求，可向品牌督导同时递交入队申请。</p>
                    <p>2、在本地有良好的公益口碑，队伍负责人有一定的经济能力、时间和组织能力。</p>
                    <p>3、负责人及队长必须有大专以上学历，如原队长未达标，将给予2年缓冲期考取学历。</p>
                </div>
                {/* 申请筹备组要求end */}

                {/* 横线 */}
                <hr style={{opacity: 0.2}} />
                {/* 横线end */}

                {/* 申请筹备组流程及资料 */}
                <div style={{marginBottom:20}}>
                    <h3 style={{fontWeight: 'bold'}}>
                        申请筹备组流程及资料
                    </h3>
                    <p>1、填写申请队伍信息和申请人信息。</p>
                    <p>2、添加队员信息。</p>
                    <p>3、填写/上传申请所需资料，其中包括：《存心救援队注册申请表》《品牌确认书（筹）》《征信承诺书》《无犯罪记录承诺书》《个人信息表》《学历证明》。</p>
                    <p>4、督导官核查（包括救援装备核查、场地情况核查），二级审核（对筹备组备案是否通过做出评价）。</p>
                    <p>5、下载【授权文件】到民政局和应急局注册登记队伍信息。</p>
                    <p>6、上传已注册登记信息，管理员审核通过后，队伍信息申请成功。</p>
                </div>
                {/* 申请筹备组流程及资料end */}

                {/* 横线 */}
                <hr style={{opacity: 0.2}} />
                {/* 横线end */}

                {/* 已阅读并了解按钮 */}
                <div style={{ paddingTop: 20 }}>
                    <Radio onChange={this.RadioChang} checked={agreeFlagRadio}></Radio>
                    <span>我已阅读并已了解须知与要求</span>
                </div>
                {/* 已阅读并了解按钮end */}

                {/* 下一步跳转 */}
                <div style={{  paddingTop: 70, paddingBottom: 70,display:'flex',justifyContent:'center' }}  >
                    <Button style={{ width: 500, height: 40,backgroundColor:'#1890FF',paddingLeft:15,paddingRight:15,color:'#fff' }}   onClick={this.navigatorToNextPage}>下一步</Button>
                </div>
                {/* 下一步跳转end */}

                {/* 注意事项 */}
                <div>
                    <p>注：申请队伍负责人
                        <span style={{ color: 'red', fontWeight: 800 }}>核查</span>
                        所申请市（部分省份以区镇级未申请建队单位，具体请咨询所在省份品牌督导）是否已存在存心救援队或被存心救援品牌授权的组织，
                        确认该地区无存心救援队时方可申请建队。可通过
                        <Link to="/ranks"><span style={{ color: '#1890FF' }} onClick={this.navigatorToTeamList}>【队伍管理-队伍列表】</span></Link>或
                        <Link to="/"><span style={{ color: '#1890FF' }} onClick={this.navigatorToHome}>【首页-搜索框】</span></Link>查询</p>
                </div>
                {/* 注意事项end */}

            </div>
        )

        // 判断当前应该渲染哪个页面
        if (page == 1) {
            pageContent = indexPage
        } else if (page == 2) {
            pageContent = (<InformationFilling setPage={this.setPage.bind(this)} />);
        } else if (page == 3) {
            pageContent = (<AddTeamMembers setPage={this.setPage.bind(this)} />);
        } else if (page == 4) {
            pageContent = (<UploadInformation setPage={this.setPage.bind(this)} />);
        } else if (page == 5) {
            pageContent = (<MyApplication setPage={this.setPage.bind(this)} />);
        }

        // 渲染层
        return (
            <div>
                <Spin spinning={this.state.spin}>
                    {pageContent}
                </Spin>

            </div>

        )
    }
}



export default PreparatoryTeamApplication



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplication.jsx